import React from 'react';
import { useStyletron } from 'baseui';
import { Button, SIZE } from 'baseui/button';
import { LabelXSmall } from 'baseui/typography';
import { ACTION_TYPE } from '../../../constants';
import { SEQUENCE_LABEL_NEXT } from '../constants';
type PropsT = {
  actionConfig?: string[];
  isTracking: boolean;
  isInterpolating: boolean;
  isSequenceValid: boolean;
  isTrackingValid: boolean;
  validationError: string | null;
  onTrack?: () => void;
  onInterpolate?: () => void;
  showNextButton?: boolean;
  onNext?: () => void;
};
export const SequenceActions = ({
  actionConfig,
  isTracking,
  isInterpolating,
  isSequenceValid,
  isTrackingValid,
  validationError,
  onTrack,
  onInterpolate,
  showNextButton = false,
  onNext
}: PropsT) => {
  const [css, theme] = useStyletron();
  return <div className={css({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.sizing.scale300,
    width: '100%'
  })}>
      {validationError && <LabelXSmall color={theme.colors.negative} marginLeft={theme.sizing.scale300}>
          {validationError}
        </LabelXSmall>}
      <div className={css({
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center'
    })}>
        <div className={css({
        display: 'flex',
        gap: theme.sizing.scale300,
        width: '100%',
        paddingLeft: theme.sizing.scale0
      })}>
          {(!actionConfig || actionConfig?.includes(ACTION_TYPE.INTERPOLATION)) && <Button size={SIZE.mini} disabled={isTracking || isInterpolating || !isSequenceValid} isLoading={isInterpolating} onClick={onInterpolate} overrides={{
          BaseButton: {
            style: {
              width: '100%'
            }
          }
        }}>
              Interpolate
            </Button>}
          {actionConfig?.includes(ACTION_TYPE.TRACK) && (showNextButton ? <Button size={SIZE.mini} disabled={!isSequenceValid} onClick={onNext} overrides={{
          BaseButton: {
            style: {
              width: '100%'
            }
          }
        }}>
                {SEQUENCE_LABEL_NEXT}
              </Button> : <Button size={SIZE.mini} disabled={isTracking || !isTrackingValid || !isSequenceValid} onClick={onTrack} isLoading={isTracking} overrides={{
          BaseButton: {
            style: {
              width: '100%'
            }
          }
        }}>
                Track
              </Button>)}
        </div>
      </div>
    </div>;
};